import { css } from '@emotion/react'
import { ExternalStyles, Theme, Tooltip, useTheme } from 'bold-ui'
import { ReactComponent as AgendamentoCompartilhadoIcon } from 'images/agenda/calendar-add-filled.svg'

interface AgendaOnlineMarkerProps {
  styles?: ExternalStyles
}

export function AgendamentoCompartilhadoMarker(props: AgendaOnlineMarkerProps) {
  const { styles } = props

  const theme = useTheme()
  const { iconeAgendamentoCompartilhado } = createStyles(theme)

  return (
    <Tooltip text='Agendamento entre profissionais'>
      <AgendamentoCompartilhadoIcon css={css(iconeAgendamentoCompartilhado, styles)} />
    </Tooltip>
  )
}

const createStyles = (theme: Theme) => ({
  iconeAgendamentoCompartilhado: css`
    fill: ${theme.pallete.primary.c50};
    height: 1rem;
    width: 1rem;
    align-self: center;
  `,
})
